import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './ktm-controls.css';
import reportWebVitals from './reportWebVitals';
import {addRoutes as addRoutesPlanadmin} from 'planadmin';

addRoutesPlanadmin();

let content = <App />

ReactDOM.render(
  <React.StrictMode>
    {content}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();





